import React, { useEffect } from "react";
// import ReactMarkdown from "react-markdown";
// import { graphql } from "gatsby";
import Layout from "../components/Layout";
import "../styles/news.scss";
import { __DEV__ } from "../Constants";

// used for cms and page
export function SeparateNewsTemplate(props) {
  const { published, content, className } = props;
  
  useEffect(() => {
    if (__DEV__) {
      require('fslightbox').default
      const allImgs = document.querySelectorAll('a[imageanchor]')
      for (let a of allImgs) {
        a.setAttribute('data-fslightbox', 'gallery')
      }
      // magic ...
       window.refreshFsLightbox()
    }
  })
  return (
    <section className={`news  ${className && className}`} key={published}>
      <div className="news-meta">
        <p className="news-metaField  news-metaField--date">
          <span className="news-label">Datum:</span> {published}
        </p>
      </div>
      <div>
        <div dangerouslySetInnerHTML={{ __html: content }} />
        {/* <ReactMarkdown className="about-description" source={rawMarkdownBody} /> */}
        {/* {(slikce || []).map(item => (
          <img src={item.image} />
        ))} */}
      </div>
    </section>
  );
}

const SeparateNewsPage = props => {
  // console.log(props)
  const { published, content, title } = props.pageContext;
  return (
    <Layout title={title}>
      <SeparateNewsTemplate content={content} published={published} />
    </Layout>
  );
};

export default SeparateNewsPage;

// export const separateNewsQuery = graphql`
//   query($slug: String!) {
//     news: markdownRemark(fields: { slug: { eq: $slug } }) {
//       frontmatter {
//         title
//         formattedDate: date(formatString: "DD MMMM YYYY", locale: "sl")
//         rawDate: date
//         slikce {
//           image
//           imageAlt
//         }
//       }
//       html
//       rawMarkdownBody
//     }
//   }
// `;
